import { FINLAND_ADMIN1_PLACE_IDS, getFinlandRegionChildren } from '../facets/finland-region-hierarchy';
import { getRegionTagLabel, getRegionTagType } from '../facets/region-tag-labels';

type Locale = 'en' | 'fi' | 'sv';

let finnishTownPlaceIds: Set<string> | null = null;

function isFinnishTownPlaceId(placeId: string): boolean {
  if (!finnishTownPlaceIds) {
    finnishTownPlaceIds = new Set(FINLAND_ADMIN1_PLACE_IDS.flatMap((admin1) => getFinlandRegionChildren(admin1)));
  }
  return finnishTownPlaceIds.has(placeId);
}

/**
 * The `location` facet value ("Kuopio, Suomi" on fi, "Kuopio, Finland" on en/sv) for a Finnish
 * town gazetteer placeId, or null for anything else (regions, countries, foreign cities, remote
 * scopes).
 *
 * Job cards and the job page breadcrumb used to link a town as a `regionTags` refinement
 * (`/fi/tyopaikat?regionTags=650224`), a filtered search URL instead of the town's own location
 * page. Refining `location` with this value instead makes the search router emit the town's
 * canonical pretty path (`/fi/tyopaikat/alue/kuopio_suomi`), the same page and filter the
 * location page itself uses, so the link, the address bar and the page all agree.
 */
export function finnishTownLocationRefinementValue(placeId: string | null | undefined, locale: Locale): string | null {
  if (!placeId || getRegionTagType(placeId) !== 'city' || !isFinnishTownPlaceId(placeId)) return null;
  const name = getRegionTagLabel(placeId, locale);
  if (!name) return null;
  return `${name}, ${locale === 'fi' ? 'Suomi' : 'Finland'}`;
}
